var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useCallback } from 'react';
import { submit } from 'redux-form';
import { isViewRequestStatusApproved } from '../../../../helpers/rfp';
/**
 * 質問確認のuse
 * @param dispatch
 * @param formName
 * @returns {*}
 */
const useQuestionConfirmModal = (dispatch, formName) => {
    const [isShow, changeModal] = useState(false);
    const showModal = useCallback(() => {
        changeModal(true);
    }, [changeModal]);
    const hideModal = useCallback(() => {
        changeModal(false);
    }, [changeModal]);
    const onSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(submit(formName));
    }), [dispatch, formName]);
    return {
        hideModal,
        isShow,
        onSubmit,
        showModal,
    };
};
/**
 * 案件情報に応じてHocでリダイレクト処理を行う
 * @returns {*}
 */
const questionRedirect = {
    redirectCallback: (rfp) => {
        const { id, view_request_status: viewRequestStatus } = rfp;
        const redirect = `/project/professional/${id}`;
        // 閲覧承認後に質問ページを表示する
        return isViewRequestStatusApproved(viewRequestStatus) ? '' : redirect;
    },
};
export const rfpQuestionUseCase = {
    questionRedirect,
    useQuestionConfirmModal,
};
export default rfpQuestionUseCase;
